<!-- KYMW1203 一括設定 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">一括設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <!-- 価格パターン -->
          <label class="list-input-title">価格パターン</label>
          <div class="list-input-content">
            <select [(ngModel)]="model.pricePattern" [style.width.px]="100" [tabindex]="0">
              <ng-template ngFor let-item [ngForOf]="PRICE_PATTERN_LIST">
                <option class="align-center" [value]="item.Code" [innerHTML]="item.Name"></option>
              </ng-template>
            </select>
          </div>
          <!-- 設定間隔 -->
          <label class="list-input-title">設定間隔</label>
          <div class="list-input-content">
            <ng-template ngFor let-item [ngForOf]="SETTING_SPAN_LIST">
              <app-radio-label [value]="item.Code" [label]="item.Name" groupName="" forcedEnabledMode="true"
                [tabindex]="0" [(ngModel)]="model.settingSpan">
              </app-radio-label>
            </ng-template>
          </div>
          <!-- 終了受注コード -->
          <label class="list-input-title">終了受注コード</label>
          <div class="list-input-content">
            <app-versatile-combo-box #cmb_Order [(ngModel)]="model.endOrder" [listSource]="model.filteredOrderCodeList"
              valueField="OrderCode" labelField="OrderCode" [tabindex]="0" [visible]="true" [autofocus]="false"
              (change)="orderChange()" [style.width.px]="200" forcedEnabledMode="true">
            </app-versatile-combo-box>
          </div>
          <!-- 終了企画回 -->
          <label class="list-input-title">終了企画回</label>
          <div class="list-input-content">
            <app-versatile-combo-box #cmb_Catalog [(ngModel)]="model.endCatalog"
              [listSource]="model.filteredOrderCodeList" valueField="CatalogID" labelField="CatalogID" [tabindex]="0"
              [visible]="true" [autofocus]="false" (change)="catalogChange()" [style.width.px]="200"
              forcedEnabledMode="true">
            </app-versatile-combo-box>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button #btn_Set class="btn-primary" (click)="set()" [tabindex]="0" forcedEnabledMode="true">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>